import { useModalContext } from '../ModalContext';

const clone = (x) => JSON.parse(JSON.stringify(x))

// Config sections can be absent on jobs saved before that section existed,
// so a missing intermediate object is expected, not an error.
const objectPath = (o, fieldPath) => {
  let value = o;
  for(let field of fieldPath) {
    if(value === undefined || value === null) return undefined
    value = value[field]
  }
  return value
}

const setObjectPath = (o, fieldPath, newValue) => {
  let value = o;
  for(let field of fieldPath.slice(0, fieldPath.length - 1)) {
    if(value[field] === undefined || value[field] === null) {
      value[field] = {}
    }
    value = value[field]
  }
  value[fieldPath[fieldPath.length - 1]] = newValue
}

export const createJobConfigHooks = ({partner, defaultConfig}) => {
  const useJobGeneralConfig = (fieldPath) => {
    const { formState, setFormState } = useModalContext();
    // XXX: hack to set some defaults
    if(!formState.values.databaseName) {
      formState.values.databaseName = 'charlotte'
      formState.values.partner = partner
      formState.values.status = 'pending'
      formState.values.runOnSchedule = false
    }
    const value = objectPath(formState.values, fieldPath);
    const setField = (newValue) => {
      const updatedFormState = clone(formState)
      setObjectPath(updatedFormState.values, fieldPath, newValue)
      setFormState(updatedFormState)
    }
    return [value, setField];
  }

  const useJobConfig = (fieldPath) => {
    const [ rawConfig, setRawConfig ] = useJobGeneralConfig(["config"])
    const config = rawConfig === "{ }" ? clone(defaultConfig) : JSON.parse(rawConfig)
    const value = objectPath(config, fieldPath);
    const setField = (newValue) => {
      setObjectPath(config, fieldPath, newValue)
      setRawConfig(JSON.stringify(config, 0, 2))
    }
    return [value, setField];
  }

  // Like useJobConfig, but for setting several sibling fields at once.
  // useJobConfig's setters each independently re-parse `config` from the current
  // rawConfig string, so calling two of them back-to-back in the same handler
  // silently drops one of the writes (the second setter starts from a copy that
  // doesn't see the first setter's change yet, since state hasn't re-rendered).
  // Use this instead whenever a single user action needs to change multiple
  // top-level config fields together (e.g. mutually exclusive boolean flags).
  const useJobConfigPatch = () => {
    const [ rawConfig, setRawConfig ] = useJobGeneralConfig(["config"])
    const config = rawConfig === "{ }" ? clone(defaultConfig) : JSON.parse(rawConfig)
    const patchConfig = (patch) => {
      setRawConfig(JSON.stringify({ ...config, ...patch }, 0, 2))
    }
    return [config, patchConfig];
  }

  return { useJobGeneralConfig, useJobConfig, useJobConfigPatch }
}
